module.exports = __webpack_public_path__ + "src/components/status-bubble-unselected.2925116a6a162596ed768f6a9cf79770.svg";